import { useContext, useEffect, useRef, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import Layout from "../Layout/Layout";
import { getStories, getStoryCategories } from "./utilities/ApiCalls";
import "../css/Stories.css";
import Context from "../Context";
import styled from "styled-components";
import { setPageTitle } from "../utils/titleUtils";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
const Stories = (props) => {
  const location = useLocation();

  useEffect(() => {
    setPageTitle(location.pathname);
  }, [location]);
  const history = useHistory();
  const { state } = useContext(Context);
  const query = new URLSearchParams(props.location.search);
  let search = query.get("search");

  const { t } = useTranslation();

  const [stories, setStories] = useState([]);
  const [categories, setCategories] = useState([]);
  const [categoryName, setCategoryName] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  const observer = useRef();
  const lastStoryElementRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPageNo((prevPage) => prevPage + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );

  useEffect(() => {
    let params = { moduleType: 1 };
    getStoryCategories(params).then((response) => {
      setCategories(response.data);
    });
  }, []);

  // Reset state when category changes
  const handleCategoryChange = (category) => {
    setCategoryName(category);
    setStories([]);
    setPageNo(1);
    setHasMore(true);
  };

  useEffect(() => {
    fetchStories();
  }, [categoryName, pageNo, search]);

  const fetchStories = async () => {
    try {
      setLoading(true);
      let data = {
        pageNo: pageNo,
        categoryName: categoryName,
      };

      if (search) {
        data.search = search;
      }

      const response = await getStories(data);
      const newStories = response.data || [];

      if (newStories.length === 0) {
        setHasMore(false);
      } else {
        setStories((prevStories) => {
          // For category change, replace stories
          if (pageNo === 1) {
            return newStories;
          }

          // For pagination, append unique stories
          const uniqueStories = newStories.filter(
            (newStory) =>
              !prevStories.some((story) => story._id === newStory._id)
          );
          return [...prevStories, ...uniqueStories];
        });
      }
    } catch (error) {
      console.error("Error fetching stories:", error);
      setHasMore(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#0f1817",
        }}
      >
        <Root>
          <div className="stories-container">
            <div className="header">
              <div className="stories">{t("Stories.Stories")}</div>
              <div className="select">
                <select
                  id="categoryDropdown"
                  value={categoryName}
                  onChange={(e) => handleCategoryChange(e.target.value)}
                  className="drop-down"
                >
                  <option value="">Genres</option>
                  {categories.map((category) => (
                    <option key={category._id} value={category.name}>
                      {category.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="grid-container">
              {stories.map((data, index) => {
                const isLastStory = stories.length === index + 1;
                return (
                  <Link
                    key={data._id}
                    ref={isLastStory ? lastStoryElementRef : null}
                    className="cart"
                    to={`/story-details/${data._id}`}
                  >
                    <div className="cart">
                      <div className="img-contiainer">
                        <img
                          src={data.thumbnail}
                          className="img-stories"
                          alt={data.name}
                        ></img>
                        <div className="hover-text">
                          <p className="content">{data.description}</p>
                        </div>
                      </div>
                      <div className="title">{data.name}</div>
                    </div>
                  </Link>
                );
              })}
            </div>

            {stories.length === 0 && !loading && (
              <div style={{ textAlign: "center", color: "white" }}>
                No Stories Found
              </div>
            )}

            {loading && (
              <div style={{ textAlign: "center", color: "white" }}>
                {t("Loading")}
              </div>
            )}

            {/* {!hasMore && stories.length > 0 && (
              <div style={{ textAlign: "center", color: "white" }}>
                No more stories to load
              </div>
            )} */}
          </div>
        </Root>
      </div>
    </Layout>
  );
};

export default Stories;

const Root = styled.div`
  min-height: 100vh;
  background-color: #0f1817;
  height: auto;
  width: 100%;

  display: flex;
  max-width: 1300px;

  .stories {
    color: white;
    font-size: 25px;
    font-weight: bold;
  }

  .hover-text {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 20px;
    padding-left: 10px;
    padding-right: 10px;
    opacity: 0;
    line-height: 1.2; /* Adjust line height as needed */
    letter-spacing: -0.6px; /* Adjust letter spacing as needed */
    overflow: hidden;
    text-align: center;
    white-space: normal;
    text-overflow: ellipsis;
    &:hover {
      opacity: 1; /* Display when hovered */
      background-color: rgba(0, 0, 0, 0.7);
    }

    @media (min-width: 350px) and (max-width: 600px) {
      font-size: 15px;
    }
  }

  .hover-text {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    display: flex;
    border-radius: 20px;
    opacity: 0;
    overflow: hidden;
    padding: 0 10px;
    &:hover {
      opacity: 1; /* Display when hovered */
      background-color: rgba(0, 0, 0, 0.7);
    }
  }

  .content {
    letter-spacing: -0.5px; /* Adjust as needed */
    font-size: 14px; /* Adjust as needed */
    overflow: hidden;
    color: white;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
  }

  .drop-down {
    padding: 4px;
    min-width: 100px;
    width: auto;
    border-radius: 20px;
    color: #bd2130;
  }

  .header {
    width: 100%;
    justify-content: space-between;
    padding-left: 30px;
    padding-right: 30px;
    display: flex;
    align-items: center;
    margin-top: 50px;
    @media (min-width: 1100px) {
      max-width: 1300px;
      padding-right: 75px;
    }
  }

  .thumbnail {
    width: 100%;
    height: 80%;
    border-radius: 20px;
  }

  .cart {
    height: 248px;
    max-height: 250px;
    max-width: 350px;
    display: flex;
    flex-direction: column;

    @media (min-width: 600px) and (max-width: 790px) {
      height: 190px;
      max-height: 200px;
      max-width: 200px;
    }
    @media (min-width: 350px) and (max-width: 600px) {
      height: 190px;
      max-height: 200px;
      max-width: 200px;
    }
  }

  .img-contiainer {
    height: 80%;
    width: 100%;
    position: relative;
    border-radius: 20px;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .img {
    height: 100%;
    width: 100%;
    border-radius: 20px;
  }

  .img-stories {
    margin-top: 0px;
    height: 100%;
    width: 100%;
    border-radius: 20px;
  }

  .title {
    margin-left: 5px;
    ${"" /* height:100px; */}
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    letter-spacing: -1px;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1; /* Limits the text to two lines */
    line-clamp: 1; /* Not yet standard, but good to include */
    white-space: normal; /* Allow text to wrap to the next line */
    width: 90%;
    color: white;
    text-transform: capitalize;
    @media (min-width: 350px) and (max-width: 500px) {
      font-size: 10px;
      width: 90%;
    }

    @media (min-width: 701px) and (max-width: 900px) {
      font-size: 14px;
      width: 90%;
    }
  }

  .grid-container {
    display: grid;
    width: 100%;
    grid-template-columns: repeat(
      3,
      1fr
    ); /* 3 columns, each taking 1 fraction of the available space */
    gap: 25px; /* Space between grid items */
    padding: 20px;
    padding-left: 25px;
    padding-right: 25px;
    @media (min-width: 350px) and (max-width: 600px) {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  .btn {
    margin-top: 25px;
    background-color: #bd2130;
    color: white;
    font-weight: semibold;
    border-radius: 20px;
  }
  .adventure-title {
    color: white;
    font-size: 30px;
    font-family: "Georgia, serif";
  }

  .sub-title {
    color: white;
    font-family: "Georgia, serif";
    @media (min-width: 350px) and (max-width: 400px) {
      font-size: 12px;
      letter-spacing: 0.3px;
    }
  }

  .stories-container {
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
  }
`;
